

import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

import { MwcSafeAny } from 'mwc/core/types';

@Component({
  selector: 'mwc-option-item-group',
  template: ` <ng-container *mwcStringTemplateOutlet="mwcLabel">{{ mwcLabel }}</ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'mwc-select-item mwc-select-item-group'
  }
})
export class MwcOptionItemGroupComponent {
  @Input() mwcLabel: string | number | TemplateRef<MwcSafeAny> | null = null;

  constructor() {}
}
